import { style } from "@vanilla-extract/css";
import playIcon from "plos/src/img/icons/play.svg";
import { vars } from "plos/src/styles";

export const newsImg = style({
  aspectRatio: "16/9",
  display: "block",
  transition: "opacity 0.4s ease-in-out, transform 0.4s ease-in-out",
  borderRadius: vars.radii.m,
  objectFit: "cover",
  width: "100%",
});

export const videoImgWrapper = style({
  position: "relative",
  transition: "all 0.2s",
  selectors: {
    "&::before, &::after": {
      position: "absolute",
      borderRadius: vars.radii.s,
      backgroundImage: `url(${playIcon})`,
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "16px",
      width: 24,
      height: 24,
      content: "''",
    },
    "&::before": {
      bottom: vars.space.xs,
      insetInlineEnd: vars.space.xs,
      transition: "opacity 0.2s ease, transform 0.2s ease",
      opacity: 1,
      backgroundColor: vars.colors.primaryFixed,
      padding: vars.space.xs,
    },
    "&::after": {
      top: "50%",
      insetInlineStart: "50%",
      transform: "translate(-50%, -50%)",
      transition: "opacity 0.3s ease, transform 0.3s ease",
      opacity: 0,
      backgroundColor: vars.colors.glass,
    },
    "&:hover::before": {
      opacity: 0,
    },
    "&:hover::after": {
      opacity: 1,
    },
  },
});
